/* eslint-disable react/no-unescaped-entities */

import { Meta } from '@/layout/Meta'
import { Main } from '@/templates/Main'
import { useCookie } from '@/utils/Session'
import { useRouter } from 'next/router'
import react, { useEffect } from 'react'
import { User } from './api/user'
import { note } from '@/utils/Note'

const Account = () => {
  useEffect(() => {
    note('Visited Account')
  }, [])
  
  const [sessionId] = useCookie('sessionId')
  const router = useRouter()

  // DB Connection Details
  const [user, setUser] = react.useState<string>()
  const [accountType, setAccountType] = react.useState<string>()
  const [refresh, setRefresh] = react.useState<string>()
  const [maxConnections, setMaxConnections] = react.useState<number>()
  const [maxQueriesPerHour, setMaxQueriesPerHour] = react.useState<number>()
  const [paidThrough, setPaidThrough] = react.useState<string>()

  const fetchUserData = async () => {
    const resp = await fetch('/api/user?sessionId='+sessionId(), {
      method: 'get',
    })

    if (!resp.ok) {
      return false
    }

    return resp.json()
  }

  react.useEffect(() => {
    console.debug('getting user data')

    if (!sessionId()) {
      router.push('/login')
      return
    }
    
    fetchUserData().then((r: User) => {
      console.info('connected apps->', r)

      const paidThrough = r.subscription ? 
        new Date(r.subscription.paidThrough).toLocaleDateString() : 
        'n/a'

      setUser(r.dbId || 'n/a')
      setAccountType(r.accountType || 'Free')
      setRefresh(r.refreshDelay || 'week')
      setMaxConnections(r.maxConnections || 1)
      setMaxQueriesPerHour(r.maxQueriesPerHour || 60)
      setPaidThrough(paidThrough)
    })
  }, []);

  function friendlyAccountType(accountType?: string) {
    if (!accountType) {
      return ''
    }

    return accountType?.charAt(0).toUpperCase() + accountType?.slice(1)
  }

  function friendlyRefreshDelay(refreshDelay?: string) {
    switch (refreshDelay) {
      case 'week':
        return 'Weekly'
      case 'day':
        return 'Daily'
      case 'hour':
        return 'Hourly'
      case 'minute':
        return 'Every Minute'
      default:
        return 'None'
    }
  }

  return (
    <Main meta={<Meta 
        title="Account - Dessert Data"
        description="Export your digital advertising data into a SQL database." />}>
      <section className="p-3">
        <h1 className="font-bold text-2xl text-sky-700 bg-slate-100">Your Account</h1>
        <table>
          <tbody>
            <tr>
              <td className="text-right">Account Type</td>
              <td className="font-semibold pl-5">{ friendlyAccountType(accountType) }</td>
            </tr>
            <tr>
              <td className="text-right">Refresh Frequency</td>
              <td className="font-semibold pl-5 capitalize">{ friendlyRefreshDelay(refresh) }</td>
            </tr>
            <tr>
              <td className="text-right">Max Connections</td>
              <td className="font-semibold pl-5 capitalize">{maxConnections}</td>
            </tr>
            <tr>
              <td className="text-right">Max Queries Per Hour</td>
              <td className="font-semibold pl-5 capitalize">{maxQueriesPerHour}</td>
            </tr>
          </tbody>
        </table>
      </section>
      <section className="mt-8 p-3">
        <h2 className="font-bold text-xl text-sky-700  bg-slate-100">Payment Info</h2>
        Paid Through: <span className="font-semibold">{paidThrough}</span>
      </section>
      <section className="mt-8 p-3 hidden">
        <h2 className="font-bold text-xl text-sky-700 bg-slate-100">Database Connection Details</h2>
        <p>
          Use these details to connect to your database using any MySQL compatible client.
        </p>
        <table>
          <tbody>
            <tr>
              <td className="text-right">Host</td>
              <td className="font-light pl-5 font-mono">db.dessertdata.com</td>
            </tr>
            <tr>
              <td className="text-right">Username</td>
              <td className="font-light pl-5 font-mono">{ user }</td>
            </tr>
            <tr>
              <td className="text-right">Password</td>
              <td className="font-light pl-5 font-mono">[ Same password as for this site ]</td>
            </tr>
            <tr>
              <td className="text-right">Database</td>
              <td className="font-light pl-5 font-mono">{ user }</td>
            </tr>
            <tr>
              <td className="text-right">Port</td>
              <td className="font-light pl-5 font-mono">3306</td>
            </tr>
          </tbody>
        </table>
      </section>
    </Main>
  );
};

export default Account
